import React from 'react';
import searchIcon from 'assets/img/icons/search.svg';
import SearchResult from './SearchResult';
import ExerciesCreate from './ExerciesCreate';

class SearchEngine extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      searchTerm: '',
      currentlyDisplayed: [],
      selectedExercise: null,
      modalOpen: false,
      showResults: false
    }
  }

  handleChange = event => {
    const searchTerm = event.target.value;
    this.setState({
      searchTerm: searchTerm,
      currentlyDisplayed: searchTerm ?
        ((this.props.trainerExercies || []).filter(exercies => {
          return (exercies.name.toLocaleLowerCase()).indexOf(searchTerm.toLocaleLowerCase()) !== -1;
        })) : []
    })
  };

  handleSelectResult = exercise => {
    this.setState({
      searchTerm: '',
      currentlyDisplayed: [],
      selectedExercise: exercise,
      showResult:false
    });
    this.props.selectResult(exercise);
  }

  handleShowResults = (value) => {
    this.setState({showResults: value});
  }

  handleModalOpen =(value) => {
    this.setState({modalOpen: value});
  }

  render() {
    let { searchTerm, currentlyDisplayed, showResults, modalOpen } = this.state;
    return (
      <div className="exercies-search">
        <div className="form-group form-group-search">
          <label className="form-label">
              {' '}
              Exercise Name{' '}
          </label>
          <input
            name="name"
            type="text"
            autoComplete="off"
            placeholder="Search Exercise"
            className="form-control"
            value={searchTerm}
            onChange={this.handleChange}
            onFocus={e => {
              this.handleShowResults(true);
            }}
          />
          <span>
            <img alt="search icon" src={searchIcon} />
          </span>
        </div>
        {
          (currentlyDisplayed.length > 0 || (showResults || searchTerm.length > 0)) &&
          (
            <SearchResult
              handleSelectResult={this.handleSelectResult}
              exercies={currentlyDisplayed}
              showResults={showResults}
              handleShowResults={this.handleShowResults}
              setModalOpen={this.handleModalOpen}
            />
          )
        }
        <ExerciesCreate
            openModal={modalOpen}
            setModalOpen={this.handleModalOpen}
            handleSelectResult={this.handleSelectResult}
          />
      </div>
    );
  }
}

export default SearchEngine;
